var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.steps),function(step,index){return _c('v-card',{key:index,staticClass:"step-tile me-1",style:(_vm.tileStyle(step)),attrs:{"color":_vm.tileColor(step)}},[_vm._v(" "+_vm._s(index + 1)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }